var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomHazard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C7B97",
    d: "M53.8987381,29.201087 L76.3903285,67.3532609 C78.1247751,70.2880435 75.949667,73.9565217 72.4995428,73.9565217 L27.5070233,73.9565217 C24.0381301,73.9565217 21.881791,70.2789081 23.6068989,67.3532609 L46.0984893,29.201087 C47.8329359,26.2663043 52.1737218,26.2663043 53.8987381,29.201087 Z M50,63.3913043 C48.7003106,63.3913043 47.6521739,64.439441 47.6521739,65.7391304 C47.6521739,67.0388199 48.7003106,68.0869565 50,68.0869565 C51.2996894,68.0869565 52.3478261,67.0388199 52.3478261,65.7391304 C52.3478261,64.439441 51.2996894,63.3913043 50,63.3913043 Z M51.7544945,39.9130435 L48.2455106,39.9130435 C47.9094003,39.9130435 47.6425005,40.1974718 47.6524429,40.5429128 L47.6524429,40.5429128 L48.3937775,60.4542841 C48.4036234,60.7895067 48.6705232,61.0434783 48.9868452,61.0434783 L48.9868452,61.0434783 L51.0131599,61.0434783 C51.329482,61.0434783 51.5962852,60.7793875 51.6062276,60.4542841 L51.6062276,60.4542841 L52.3475622,40.5429128 C52.357408,40.1974718 52.0905083,39.9130435 51.7544945,39.9130435 L51.7544945,39.9130435 Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomHazard);
export default __webpack_public_path__ + "static/media/custom-hazard.6ef5f254.svg";
export { ForwardRef as ReactComponent };